<crm-single-select
  #singleSelectComponent
  [options]="users"
  optionLabel="profile.name"
  filterBy="profile.name"
  [isFilterSelectedItem]="true"
  [(selectedItem)]="selectedUser"
  (selectedItemChange)="selectedUserChange.emit($event)"
  [label]="labelInput ? 'Пользователь' : ''"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [appendTo]="appendTo"
  [scrollHeight]="scrollHeight"
  [disabled]="disabled"
  [showClear]="showClear"
  [placeholder]="placeholder"
  [sort]="sort"
  [itemSubDescriptionField]="itemSubDescriptionField">
  <ng-template
    #itemTemplate
    let-user="item">
    <ng-container *ngIf="toUser(user) as user">
      <div class="flex align-items-center gap-2">
        <div>{{ user.profile?.name || 'Неизвестно' }}</div>
        <div
          *ngIf="user?.banned"
          class="font-medium text-red-500">
          (Заблокирован)
        </div>
      </div>
    </ng-container>
  </ng-template>
</crm-single-select>
